import type { IconNode } from '../types';

/**
 * @name bat-ball
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8Y2lyY2xlIGN4PSIxOCIgY3k9IjE4IiByPSI0IiAvPgogIDxwYXRoIGQ9Im00IDggMTAgMTAiIC8+CiAgPHBhdGggZD0iTTIwLjggMTUuMmMxLjktMy40IDEuNC03LjctMS40LTEwLjYtMy41LTMuNS05LjEtMy41LTEyLjUgMC00LjcgNC43LTUuMSA2LjktMS40IDExLjFsLTIuOSAyLjljLS44LjgtLjggMiAwIDIuOC44LjggMiAuOCAyLjggMGwyLjktMi45YzIuNiAyLjMgNC41IDMgNi42IDIuMSIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/bat-ball
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const batBall: IconNode = [
  ['circle', { cx: '18', cy: '18', r: '4', key: 'lned0m' }],
  ['path', { d: 'm4 8 10 10', key: 'jo9by3' }],
  [
    'path',
    {
      d: 'M20.8 15.2c1.9-3.4 1.4-7.7-1.4-10.6-3.5-3.5-9.1-3.5-12.5 0-4.7 4.7-5.1 6.9-1.4 11.1l-2.9 2.9c-.8.8-.8 2 0 2.8.8.8 2 .8 2.8 0l2.9-2.9c2.6 2.3 4.5 3 6.6 2.1',
      key: 'mriw03',
    },
  ],
];

export default batBall;
